<template>
    <div class="row">
        <div class="col d-flex align-items-center justify-content-between">

            <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                    <h6 class="mb-0 ms-3">
                        {{ subRetailer.name }}
                    </h6>
                </div>
                <div class="ms-5">
                    <label class="mb-0 text-xs">
                        Balance:
                        <strong v-if="subRetailer.remainingBalance">
                            &#8369;
                            {{ subRetailer.remainingBalance.toLocaleString("en") }}
                        </strong>
                    </label>
                    <label class="mb-0 text-xs ms-5">
                        Earmarked:
                        <strong v-if="subRetailer.earMarked">
                            &#8369;
                            {{ subRetailer.earMarked.toLocaleString("en") }}
                        </strong>

                    </label>

                    <label class="mb-0 text-xs ms-5">
                        Total Rebate To Transfer:
                        <strong v-if="subRetailer.rebate != null">
                            &#8369;
                            {{ subRetailer.rebate.toLocaleString("en") }}
                        </strong>
                    </label>

                </div>
            </div>

            <div class="icon-container-action text-dark d-flex align-items-center"
                :class="{ 'disabled-action': !subRetailer.rebate }"
                :style="{ pointerEvents: subRetailer.rebate ? 'auto' : 'none', opacity: subRetailer.rebate ? 1 : 0.5 }"
                style="font-size: 13px" @click="subtmitTransferRebate">
                <img src="/img/transfercredittowallet.png" class="me-1" alt="logo" />
                Transfer Rebate To Wallet
            </div>

        </div>
    </div>
    <GlobalModal :show="modal.show" :title="modal.title" :message="modal.message" :type="modal.type"
        @confirm="modal.onConfirm" @cancel="modal.onCancel" @close="modal.show = false" />
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import GlobalModal from "@/components/GlobalModal.vue";

export default {
    data() {
        return {
            modal: { show: false, type: 'success', title: '', message: '' }
        };
    },
    components: {
        GlobalModal
    },
    computed: {
        ...mapState({
            subRetailer: (state) => state.retailerController.subRetailer,
        }),
    },
    methods: {
        ...mapActions({
            getSubRetailerByID: "retailerController/GetSubRetailerByID",
            transferRebate: "retailerController/TransferRebate",
            getSubRetailerByID: "retailerController/GetSubRetailerByID"
        }),

        async subtmitTransferRebate() {
            if (!this.subRetailer.rebate) return;
            const confirmed = await this.showModal(
                'confirmation',
                'Confirm Rebate Transfer',
                'You are about to transfer the rebate to your wallet. Do you want to proceed?'
            );

            if (confirmed) {
                try {
                    const subRetailerID = this.subRetailer.subRetailerID;
                    const rebate = this.subRetailer.rebate;

                    let result;

                    result = await this.transferRebate({ subRetailerID, amount: rebate });
                    if (result) {
                        //alert(`Rebate transferred successfully.`);
                        await this.getSubRetailerByID(this.subRetailer.subRetailerID);
                        this.showModal(
                            'success',
                            'Rebate transferred successfully.',
                        );

                    } else {
                        this.showModal(
                            'error',
                            'Failed to transfer rebate.',
                        );
                        //alert(`Failed to transfer rebate.`);
                    }
                } catch (error) {
                    this.showModal(
                        'error',
                        'An error occurred while adding rate.',
                    );
                    //alert("An error occurred while adding rate.");
                }
            }
        },

        showModal(type, title, message) {
            return new Promise((resolve) => {
                this.modal = {
                    show: true,
                    type,
                    title,
                    message,
                    onConfirm: () => {
                        this.modal.show = false;
                        resolve(true);
                    },
                    onCancel: () => {
                        this.modal.show = false;
                        resolve(false);
                    },
                };
            });
        }
    },

    async mounted() {
        const subRetailerID = localStorage.getItem("userSubRetailerID");
        if (subRetailerID) {
            await this.getSubRetailerByID(parseInt(subRetailerID));
        }
    }
}
</script>
